module.exports = __webpack_public_path__ + "static/media/I Maket.c2ff91ee.webm";